<app-header></app-header>

<bit-container>
  <app-profile></app-profile>

  <div *ngIf="showChangeEmail$ | async" class="tw-mt-16">
    <bit-card class="tw-block">
      <bit-section-header class="tw-mb-3">
        <i class="bwi bwi-envelope tw-text-muted" aria-hidden="true"></i>
        <h2 bitTypography="h4">{{ "changeEmail" | i18n }}</h2>
      </bit-section-header>
      <app-change-email></app-change-email>
    </bit-card>
  </div>

  <app-danger-zone>
    <ng-container>
      <button
        *ngIf="verifyNewDeviceLogin"
        type="button"
        bitButton
        buttonType="dangerOutline"
        [bitAction]="setNewDeviceLoginProtection"
      >
        {{ "turnOffNewDeviceLoginProtection" | i18n }}
      </button>
      <button
        *ngIf="!verifyNewDeviceLogin"
        type="button"
        bitButton
        buttonType="secondary"
        [bitAction]="setNewDeviceLoginProtection"
      >
        {{ "turnOnNewDeviceLoginProtection" | i18n }}
      </button>
    </ng-container>
    <button type="button" bitButton buttonType="dangerOutline" (click)="deauthorizeSessions()">
      {{ "deauthorizeSessions" | i18n }}
    </button>
    <button
      *ngIf="showPurgeVault$ | async"
      type="button"
      bitButton
      buttonType="dangerOutline"
      [bitAction]="purgeVault"
    >
      {{ "purgeVault" | i18n }}
    </button>
    <button
      *ngIf="showDeleteAccount$ | async"
      type="button"
      bitButton
      buttonType="dangerOutline"
      [bitAction]="deleteAccount"
    >
      {{ "deleteAccount" | i18n }}
    </button>
  </app-danger-zone>
</bit-container>
